import { useCallback } from 'react'

import { AchievementOverlayData, useOverlayActions } from '@store'

export const useShowAchievementOverlay = () => {
  const { setOverlayQueue } = useOverlayActions()

  const showOverlay = useCallback(
    (data: AchievementOverlayData['payload']) => {
      setOverlayQueue([{ type: 'achievement', payload: data }])
    },
    [setOverlayQueue]
  )

  return { showOverlay }
}
